'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationCta = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _multitrack = require('helpers/multitrack');

var _PagePromotion = require('components/PagePromotion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCta = exports.NavigationCta = function (_Component) {
  (0, _inherits3.default)(NavigationCta, _Component);

  function NavigationCta() {
    (0, _classCallCheck3.default)(this, NavigationCta);
    return (0, _possibleConstructorReturn3.default)(this, (NavigationCta.__proto__ || (0, _getPrototypeOf2.default)(NavigationCta)).apply(this, arguments));
  }

  (0, _createClass3.default)(NavigationCta, [{
    key: 'handleLiveCtaClick',
    value: function handleLiveCtaClick() {
      (0, _multitrack.ga)('Top Nav', 'CP Live CTA Click', 'standalone');
    }
  }, {
    key: 'handleCtaClick',
    value: function handleCtaClick() {
      (0, _multitrack.ga)('Top Nav', 'Get ClassPass');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isActiveUser = _props.isActiveUser,
          isCancelledUser = _props.isCancelledUser,
          isLivePage = _props.isLivePage,
          className = _props.className;


      if (isActiveUser) {
        return false;
      }

      if (isLivePage) {
        return _react2.default.createElement(
          _reactRouter.Link,
          {
            className: 'bt bt--sm bt--text-sm header__bt',
            onClick: this.handleLiveCtaClick,
            to: '/pricing/live'
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'header.buyCta',
            defaultMessage: 'Buy now'
          })
        );
      }

      if (isCancelledUser) {
        return _react2.default.createElement(
          _reactRouter.Link,
          {
            className: 'bt bt--sm bt--text-sm header__bt',
            to: '/rejoin'
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'header.reactivateCta',
            defaultMessage: 'Reactivate'
          })
        );
      }

      return _react2.default.createElement(_PagePromotion.PagePromotionCta, {
        extraClassForLink: (0, _classnames2.default)(className, 'bt--primary bt--sm bt--text-sm header__bt'),
        onClick: this.handleCtaClick,
        ctaCopy: _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'header.getCta',
          defaultMessage: 'Get ClassPass'
        })
      });
    }
  }]);
  return NavigationCta;
}(_react.Component);

NavigationCta.propTypes = {
  className: _propTypes2.default.string,
  isLivePage: _propTypes2.default.bool,
  isActiveUser: _propTypes2.default.bool,
  isCancelledUser: _propTypes2.default.bool
};